import React, { useContext } from 'react';
import { MediaItem } from "./media-api";
import { createContextProvider, createStore } from "../components/store-utils";


export interface MediaState {
    mediaList?: MediaItem[]
    media?: MediaItem
}

type RenameOptions = {media:MediaItem, newName: string}

export type MediaAction = 
    {type:"setList", payload: MediaItem[]} |
    {type:"setMedia", payload: MediaItem} |
    {type:"rename", payload: RenameOptions} 
    

function rename(state:MediaState, {media, newName}:RenameOptions){
    media = {...media, name: newName};
    let mediaList = state.mediaList.map(m => m.id == media.id ? media : m);
    return {...state, mediaList, media}
}


function mediaReducer(state: MediaState, action: MediaAction):MediaState{
    switch(action.type){
        case "setList": return {...state, mediaList: action.payload}
        case "setMedia": return {...state, media: action.payload }
        case "rename": return rename(state, action.payload)
        
    }
}

export const [MediaContext, MediaProvider] = createContextProvider(mediaReducer, {})

